import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalImageThumbnail from 'LuxKit/Modal/ModalImageThumbnail'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import type { ImageParams } from 'components/Common/ResponsiveImage/ResponsiveImage'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import LoyaltyTierBenefitAvailabilityMessageBanner from 'loyalty/components/LoyaltyTierBenefitAvailabilityMessageBanner'
import React from 'react'

const imageParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  fit: 'center',
}

interface Props {
  image: App.Image
  discountPercent: number
}

function LandingPageLoyaltyDiscountedInsuranceBenefitsModal(props: Props) {
  const { image, discountPercent } = props

  return (
    <ModalBase size="L">
      <ModalHeader title="Travel & Cancellation Protection" />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={imageParams} />
        <ModalContent>
          <Group direction="vertical" gap={32}>
            <LoyaltyTierBenefitAvailabilityMessageBanner benefitType="discounted_insurance" />
            <BodyText variant="large">
              Travel with confidence. Enjoy {discountPercent}% off comprehensive travel protection, including cover for trip cancellations, medical emergencies, lost luggage and more. Peace of mind, for less.
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">How it works</Heading>
              <BodyText variant="large">
                Purchase your policy through Luxury Escapes to instantly apply your member-exclusive {discountPercent}% saving.<br /><br />
                Coverage is provided by our trusted protection partners, with flexible options to suit your trip. Simply select your policy during checkout or via your booking confirmation to lock in protection for your next escape.
              </BodyText>
            </VerticalSpacer>
          </Group>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default LandingPageLoyaltyDiscountedInsuranceBenefitsModal
